import { i18nFilter } from "app/filters/i18nFilter";
import { ChipDownContainer } from "@similarweb/ui-components";
import { useKeywordCompetitorsPageContext } from "app/pages/keyword-research/website-analysis/pages/search-competitors/KeywordCompetitorsPageContext";
import { GroupCreationDropdownItem } from "pro-features/components/GroupCreationDropdown/src/GroupCreationDropdownItem";

const i18n = i18nFilter();
export const SearchTypeFilter = () => {
    const { searchTypes, selectedSearchType, onSelectSearchType, searchTypeFilterPlaceholder } =
        useKeywordCompetitorsPageContext();
    const items = searchTypes.map((searchType) => {
        return (
            <GroupCreationDropdownItem
                iconName={null}
                title={i18n(searchType.text)}
                key={searchType.text}
                description={i18n(searchType.tooltipText)}
                id={searchType.id}
            />
        );
    });
    const selectedIds = selectedSearchType ? { [selectedSearchType]: true } : {};
    const selectedText = selectedSearchType ? i18n(searchTypes.find(({ id }) => id === selectedSearchType).text) : null;
    return (
        <ChipDownContainer
            width={280}
            dropdownPopupHeight={1000}
            hasSearch={false}
            selectedIds={selectedIds}
            selectedText={selectedText || ""}
            buttonText={i18n(searchTypeFilterPlaceholder)}
            onClick={onSelectSearchType}
            onCloseItem={() => onSelectSearchType(null)}
            noResultsMessage={i18n("dropdown.no.results")}
        >
            {items}
        </ChipDownContainer>
    );
};
